 var kidify;
(function($) {
  "use strict";
  kidify = (function() {
    return {
      init: function() {
        // Product
        this.relatedProducts();
        this.productForm();
        this.productQuantity();
        this.wishlist();
        this.quickview();

        // Collection
        this.collectionFilter();
        this.newCollectionFilter();
      },

      // Product
      relatedProducts: function() {
        if($(".product-recommendations").length > 0) {
          loadRelatedProducts();
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".product-recommendations").attr("data-product-id");
          var limit = $(".product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=main-product-related&limit="+limit+"&product_id="+productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
            }
          };
          request.send();
        }
      },

      productForm: function() {
        function variants(productId) {
          var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
          var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "']");
            if (variant) {
              if (variant.available) {
                $(that).find(".js-product-add-to-cart").removeClass("d-none");
                $(that).find(".js-product-out-of-stock").addClass("d-none");
              } else {
                $(that).find(".js-product-add-to-cart").addClass("d-none");
                $(that).find(".js-product-out-of-stock").removeClass("d-none");
              }
              if(variant.compare_at_price > variant.price) {
                $(that).find(".js-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                $(that).find(".js-price-new").removeClass("d-none").html(Shopify.formatMoney(variant.price));
              } else {
                $(that).find(".js-price-old").addClass("d-none")
                $(that).find(".js-price-new").removeClass("d-none")
              }
              if(variant.featured_image !== null) {
                $(that).find(".js-product-thumbnail[data-id='" + variant.featured_image.position + "']").click();
              }
            } else {
              $(that).find(".js-product-add-to-cart").addClass("d-none");
              $(that).find(".js-product-out-of-stock").removeClass("d-none");
            }
          }
          jQuery(function($) {
            if($("#product-select-" + productId + "").length > 0) {
              new Shopify.OptionSelectors("product-select-" + productId + "", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
            }
          });
        }

        $(".js-product").each(function () {
          variants($(this).attr("data-product-id"));
        });

        $(".js-product-select").click(function () {
          var option = $(this).closest(".dropdown-menu").attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).closest(".dropdown-menu").attr("data-product-id");
          $(this).closest(".dropdown-menu").find("a").removeClass("active");
          $(this).addClass("active");
          $(this).closest(".product-select").find(".js-product-select-value").html(value);
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          return false;
        });

        $(".js-product-color").click(function () {
          $(this).closest(".list-color").find("li").removeClass("active");
          $(this).closest(".list-color").find(".box-circle-color").removeClass("active");
          $(this).closest(".list-color").find("a").removeClass("active");
          $(this).addClass("active");
          $(this).parent().addClass("active");
          $(this).parent().parent().addClass("active");
          var option = $(this).closest(".list-color").attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(this).closest(".block-color").find(".js-product-color-value").html(value);
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          return false;
        });

        $(".js-product-size").click(function () {
          $(this).closest(".list-sizes").find(".js-product-size").removeClass("active");
          $(this).addClass("active");
          var option = $(this).closest(".list-sizes").attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(this).closest(".block-size").find(".js-product-size-value").html(value);
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          return false;
        });

        $("body").on("click", ".js-add-to-cart", function () {
          $(this).html($(this).attr("data-adding-text"));
          if($(this).hasClass("variant")) {
            var quantity = 1;
            var id = $(this).attr("data-variant-id");
            var properties = {};
          } else {
            var productId = $(this).attr("data-product-id");
            var quantity = $(".js-product[data-product-id='" + productId + "'] .js-quantity-field").val();
            if(isNaN(quantity)) { quantity = 1; }
            var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
            var properties = {};
            $(".js-product[data-product-id='" + productId + "'] input, .js-product[data-product-id='" + productId + "'] select, .js-product[data-product-id='" + productId + "'] textarea").each(function () {
              var getName = $(this).attr("name");
              if(typeof getName !== 'undefined') {
                if(getName.indexOf("properties") >= 0) {
                  var name = $(this).attr("name").replace("properties[", "").replace("]", "");
                  var value = $(this).val();
                  properties[name] = value;
                }
              }
            });
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function() {
              kidify.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              kidify.refreshCart();
            }
          });
          return false;
        });

        $(".js-buy-now").click(function () {
          $(".js-buy-now-content button").eq(0).click();
          return false;
        });
      },

      productQuantity: function() {
        $("body").on("click", ".js-quantity-down", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if(q_val_up > 0) {
            $(this).parent().find(".js-quantity-field").val(q_val_up-1).keyup();
          } 
          return false; 
        });
        $("body").on("click", ".js-quantity-up", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find(".js-quantity-field").val(q_val_up+1).keyup(); 
          return false; 
        });
      },

      refreshCart: function() {
        $('#cart-content').load('/cart #cart-content', function() {
          $(".account-icon.cart").click();
          $(".js-add-to-cart").each(function () {
            $(this).html($(this).attr("data-original-text"));
          });
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('.js-cart-counter').html(cart.item_count);
        });
      },

      wishlist: function() { 
        $(".js-add-to-wishlist").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var wishlist = localStorage.getItem('wishlist');
          if(wishlist == null) { wishlist = ''; }
          if(wishlist.indexOf(productHandle) >= 0) {
            $(this).html($(this).attr("data-added")).addClass("added");
          }
        });
        $(".js-add-to-wishlist-2").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var wishlist = localStorage.getItem('wishlist');
          if(wishlist == null) { wishlist = ''; }
          if(wishlist.indexOf(productHandle) >= 0) {
            $(this).addClass("added");
          }
        });
        $("body").on("click", ".js-add-to-wishlist", function () {
          if(!$(this).hasClass("added")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).html($(this).attr("data-added")).addClass(("added"));
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            return false;
          }
        });
        $("body").on("click", ".js-add-to-wishlist-2", function () {
          if(!$(this).hasClass("added")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).addClass(("added"));
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            return false;
          }
        });
        if($(".js-wishlist-body").length > 0) {
          var wishlist = localStorage.getItem('wishlist');
          var wishlistContent = '';
          if(wishlist == null) { wishlist = ''; }
          if(wishlist != '') {
            var wishlistProducts = wishlist.split(",");
            for (let i = 0; i < wishlistProducts.length; i++) {
              if(wishlistProducts[i] != '') {
                jQuery.getJSON('/products/' + wishlistProducts[i] + '.js', function (product) {
                  var first_column = '<td><div class="wishlist__product"><div class="wishlist-product__image"><a href="' + product.url + '"><img alt="Image" src="' + product.featured_image + '" /></a></div><div class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></div></div></td>';
                  var second_column = '<td><div class="wishlist-product__price">' + Shopify.formatMoney(product.price) + '</div></td>';
                  if(product.available) {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + $(".js-wishlist-body").attr("data-in-stock") + '</div></td>';
                  } else {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + $(".js-wishlist-body").attr("data-out-of-stock") + '</div></td>';
                  }
                  var fourth_column = '<td><a href="' + product.url + '" class="btn btn-brand-1-xl-bold w-100 font-md-bold">' + $(".js-wishlist-body").attr("data-add-to-cart") + '</a></td>';
                  var fifth_column = '<td><div class="wishlist-product__delete"><a href="#" class="js-delete-product-wishlist" data-product-handle="' + product.handle + '"><svg class="icon-16 d-inline-flex align-items-center justify-content-center" fill="#111111" stroke="#111111" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg></a></div></td>';
                  wishlistContent = wishlistContent + '<tr>' + first_column + '' + second_column + '' + third_column + '' + fourth_column + '' + fifth_column + '</tr>';
                });
              }
            }
          }
          setTimeout(function () {
            if(wishlistContent == '') {
              wishlistContent = '<tr><td colspan="5">' + $(".js-wishlist-body").attr("data-wishlist-empty") + '</td></tr>';
              $(".js-wishlist-body").html(wishlistContent);
            } else {
              $(".js-wishlist-body").html(wishlistContent);
            }
          }, 1000);
          $("body").on("click", ".js-delete-product-wishlist", function() {
            $(this).parent().parent().parent().remove();
            var productHandle = $(this).attr("data-product-handle");
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts);
            return false;
          });
        }
        var wishlist = localStorage.getItem('wishlist');
        if(wishlist == null) { wishlist = ''; }
        var wishlistCounter = wishlist.split(",").length - 1;
        if(wishlistCounter < 0) { wishlistCounter = 0; }
        $(".js-wishlist-counter").html(wishlistCounter);
      },

      quickview: function() {
        var rtl = false;
        if($("html[dir='rtl']").length > 0) {
          rtl = true;
        }
        $("body").on("click", ".js-open-quickview", function () {
          $(".js-quickview-content").html('<div class="quickview-loader"><div class="page-loading-inner"><div></div><div></div><div></div></div></div>');
          var productUrl = $(this).attr("data-product-url");
          $('.js-quickview-content').load(productUrl + ' #quickview', function() {
            kidify.productForm();
            $(".js-quickview-content .product-image-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                asNavFor: ".slider-nav-thumbnails",
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
                infinite: false,
                loop: false,
                dots: true,
                rtl: rtl
            });
            GLightbox({
              selector: ".js-quickview-content .glightbox"
            });
          });
        });
      },

      // Collection
      collectionFilter: function() {
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".box-sortby .dropdown-item.active").attr("data-value");
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if(Shopify.queryParams.constraint == '') {
            return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
          } else {
            return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $(".js-collection-items").addClass("loading");
            },
            success: function(result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".js-collection-items").html($(result).find(".js-collection-items").html());
              $(".js-collection-items").removeClass("loading");
              $(window).scrollTop(0);
            },
            error: function() {
              $(".js-collection-items").removeClass("loading");
            }
          })
        }

        $("input.tag").change(function () {
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          $(".size-tag.active").each(function () {
            tags.push($(this).attr("value"));
          });
          $(".color-tag.active").each(function () {
            tags.push($(this).attr("value"));
          });
          $(".tag2.active").each(function () {
            tags.push($(this).attr("value"));
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        $(".size-tag, .tag2, .color-tag").click(function () {
          $(this).toggleClass("active");
          $(this).find("span, a").toggleClass("active");
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          $(".size-tag.active").each(function () {
            tags.push($(this).attr("value"));
          });
          $(".color-tag.active").each(function () {
            tags.push($(this).attr("value"));
          });
          $(".tag2.active").each(function () {
            tags.push($(this).attr("value"));
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });
      },

      newCollectionFilter: function() {
        if($("#slider-range-filter").length > 0) {
          var i = 0;
        } else {
          var i = 2;
        }
        function renderPage(searchParams, event, counter) {
          $(".js-filter").each(function () {
            var section_id = $(this).attr("data-section-id");
            var sort_by = $(".box-sortby .dropdown-item.active").attr("data-value");
            const url = `${window.location.pathname}?section_id=${section_id}&${searchParams}&sort_by=${sort_by}`;
            const filterDataUrl = element => element.url === url;

            fetch(url)
              .then(response => response.text())
              .then((html) => {
                if(counter == i && counter > 2) {
                  $(".js-collection-items").html($(html).find(".js-collection-items").html());
                  $(".js-collection-items").removeClass("loading");
                  $(window).scrollTop(0);
                  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}&sort_by=${sort_by}`);
                }
              });
          });
        }

        $(document.body).on('change', '.js-filter input', function(event) {
          i++;
          event.preventDefault();
          const formData = new FormData(event.target.closest('form'));
          const searchParams = new URLSearchParams(formData).toString();
          renderPage(searchParams, event, i);
          if(i > 2) {
            $(".js-collection-items").addClass("loading");
          }
        });

        $(".js-color-new-filter, .js-size-new-filter, .js-tag-new-filter").click(function () {
          $(this).toggleClass("active");
          $(this).find("span, a").toggleClass("active");
          if($(this).hasClass("active")) {
            $(this).find("input").prop("checked", true).trigger("change");
          } else {
            $(this).find("input").prop("checked", false).trigger("change");
          }
          return false;
        });

        if($("#slider-range-filter").length > 0) {
          var rangeSlider = document.getElementById("slider-range-filter");
          var max = parseInt($("#slider-range-filter").attr("data-price-max"));
          var start_min = parseInt($(".js-price-min").val());
          var start_max = parseInt($(".js-price-max").val());
          var moneyFormat = wNumb({
              decimals: 0,
              thousand: ",",
              prefix: $("#slider-range-filter").attr("data-currency-prexix")
          });
          noUiSlider.create(rangeSlider, {
              start: [start_min, start_max],
              step: 1,
              range: {
                  min: [0],
                  max: [max]
              },
              format: moneyFormat,
              connect: true
          });
          rangeSlider.noUiSlider.on("update", function (values, handle) {
              $(".min-value-money-filter").html(values[0]);
              $(".max-value-money-filter").html(values[1]);
              $(".js-price-min").val(moneyFormat.from(values[0]));
              $(".js-price-max").val(moneyFormat.from(values[1])).trigger("change");
          });
        }
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  kidify.init();
});